import {
  Component,
  inject,
  OnInit,
  ChangeDetectorRef,
  HostListener,
  ElementRef,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Api } from '../../services/api';
import { MdlCall } from '../../components/mdl-call/mdl-call';
import { MdlTask } from '../../components/mdl-task/mdl-task';
import { MdlEvent } from '../../components/mdl-event/mdl-event';
import { MdlManageProspect } from '../../components/mdl-manage-prospect/mdl-manage-prospect';
import { CommonModule } from '@angular/common';
import { MdlChangeOwnerComponent } from '../../components/mdl-change-owner/mdl-change-owner';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { ActivatedRoute, Router } from '@angular/router';
import { MdlDelete } from '../../components/mdl-delete/mdl-delete';
import { Mdlfilterectivities } from '../../components/mdl-filter-activities/mdl-filter-activities';
import { NavOpportunities } from '../../components/opportunities/nav-opportunities/nav-opportunities';
import { AlertService } from '../../services/alert.service';
import { MdlManageOportunity } from '../../components/mdl-manage-opportunity/mdl-manage-opportunity';
import { MdlSelectCompanyType } from '../../components/mdl-public-private/mdl-public-private';
import { FormsModule } from '@angular/forms';
import { jwtDecode } from 'jwt-decode';
import { PermissionService } from '../../services/permission.service';
import { MontoInteligentePipe } from '../../services/montoInteligente.pipe';
type KpiKey =
  | 'enCurso'
  | 'nuevas'
  | 'ganadas'
  | 'aumentadas'
  | 'ingresadas'
  | 'sacadasFuera'
  | 'disminuidas'
  | 'perdidas'
  | 'atrasadas';

type KpiTotals = Record<KpiKey, number>;

@Component({
  selector: 'app-opportunities-detail',
  standalone: true,
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatSelectModule,
    MatButtonModule,
    MatDividerModule,
    FormsModule,
    MontoInteligentePipe
  ],
  templateUrl: './opportunities-generalview-table.html',
  styleUrl: './opportunities-generalview-table.css',
})
export class OpportunitiesGeneral implements OnInit {
  ngOnInit(): void {
    this.getCurrentUserFromToken();

    if (
      this.currentUserRole.toLowerCase() === 'admin' ||
      this.currentUserRole.toLowerCase() === 'administrador'
    ) {
      this.getEjecutivos();
    }

      this.calcularTotales();

  }

  oportunidades: any[] = [];
  totales: KpiTotals = {
  enCurso: 0,
  nuevas: 0,
  ganadas: 0,
  aumentadas: 0,
  ingresadas: 0,
  sacadasFuera: 0,
  disminuidas: 0,
  perdidas: 0,
  atrasadas: 0,
};

  all_oportunidades: any[] = [];
  isLoading: boolean = true;
  errorMessage: string = '';
  showRecentDropdown: boolean = false;
  selectedItem: string = 'todas';
  openedMenuId: string | null = null;

  currentUserName: string = '';
  currentUserRole: string = '';

  ejecutivos: any[] = [];

  editStep: number = -1;
  editAmount: number = -1;
  actualAmount: string = '';
  previousAmount: string = '';
  sgtePaso: string = '';

  isEditing: boolean = false;
  ultimoEditado: { tipo: 'importe' | 'sgte_paso'; index: number } | null = null;

  filtros = {
    fecha: '',
    propietario: '',
    cambios: '',
  };

  allMarked = false;
  constructor(
    private api: Api,
    private elementRef: ElementRef,
    private router: Router,
    private alertService: AlertService,
    public permissionService: PermissionService,
  ) {
    this.cargarOportunidades();
  }

  readonly dialog = inject(MatDialog);

  cargarOportunidades(): void {
    console.log('Oportunidad cargada:', OpportunitiesGeneral);
    this.api.showLoading();
    this.isLoading = true;
    this.errorMessage = '';

    this.api.getOpportunities().subscribe({
      next: (response: any) => {
        this.all_oportunidades = response.oportunidades;
        console.log(this.all_oportunidades);
        this.oportunidades = (response.oportunidades || response).map(
          (opportunity: any) => {
            return {
              ...opportunity,
              id: opportunity.opportunity_id || opportunity.id,
            };
          }
        );

        setTimeout(() => {
          this.api.hideLoading();
          this.isLoading = false;
        }, 500);
      },
      error: (error: any) => {
        console.error('Error al cargar oportunidades:', error);
        this.errorMessage =
          'Error al cargar oportunidades. Por favor, inténtelo de nuevo más tarde.';
        this.isLoading = false;
        this.api.hideLoading();
      },
    });
  }

  toggleRecentDropdown(): void {
    this.showRecentDropdown = !this.showRecentDropdown;
  }

  selectItem(key: string): void {
    this.selectedItem = key;
    this.showRecentDropdown = false;
  }

  toggleActionsMenu(id: string): void {
    this.openedMenuId = this.openedMenuId === id ? null : id;
    this.showRecentDropdown = false;
  }

  verDetalleOportunidad(id: string, event?: MouseEvent): void {
    if (this.isEditing) {
      console.log('✏️ Edición activa, se deshabilita verDetalleOportunidad');
      return;
    }

    if (event) {
      const target = event.target as HTMLElement;
      const isCheckbox =
        target.tagName === 'INPUT' &&
        target.getAttribute('type') === 'checkbox';
      const isDropdown = target.closest('.dropdown-container') !== null;

      if (isCheckbox || isDropdown) {
        return;
      }
    }

    if (!id || !this.esUUIDValido(id)) {
      this.mostrarMensaje('ID de Oportunidad no valido', 'error');
      return;
    }

    this.router.navigate(['opportunity', id]).then((navigationResult) => {
      if (!navigationResult) {
        this.mostrarMensaje(
          'No se pudo cargar el detalle de la oportunidad',
          'error'
        );
        console.error('Error de navegacion a Oportunities', id);
      }
    });
  }

  private esUUIDValido(id: string): boolean {
    const regex =
      /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
    return regex.test(id);
  }

  mostrarMensaje(
    mensaje: string,
    tipo: 'exito' | 'error' | 'advertencia'
  ): void {
    switch (tipo) {
      case 'exito':
        this.alertService.success('Éxito', mensaje);
        break;
      case 'error':
        this.alertService.error('Error', mensaje);
        break;
      case 'advertencia':
        this.alertService.warning('Advertencia', mensaje);
        break;
    }
  }

  openMdlCreateOportunity(): void {
    this.dialog.open(MdlSelectCompanyType, {
      minWidth: '800px',
      maxHeight: '900px',
      panelClass: 'mat-dlg-class',
      data: {
        mode: 'create',
      },
    });
  }

  openMdlDeleteOportunity(id: string): void {
    const dialogRef = this.dialog.open(MdlDelete, {
      minWidth: '400px',
      maxHeight: '600px',
      panelClass: 'mat-dlg-class',
      data: {
        mode: 'oportunity',
        id: id,
      },
    });
  }

  updateOportunity(data: any) {
    console.log('Click');
    this.dialog.open(MdlManageOportunity, {
      minWidth: '800px',
      maxHeight: '900px',
      panelClass: 'mat-dlg-class',
      data: {
        mode: 'edit',
        oportunidad: data,
      },
    });
  }

  updateMarca(id: string, event?: MouseEvent) {
    if (event) {
      event.stopPropagation();
    }
    let marcado = 0;
    for (let i = 0; i < this.oportunidades.length; i++) {
      if (this.oportunidades[i].oportunidad_id === id) {
        if (this.oportunidades[i].marcado === 0) {
          this.oportunidades[i].marcado = 1;
          marcado = 1;
        } else {
          this.oportunidades[i].marcado = 0;
          marcado = 0;
        }

        this.api
          .markOpportunity({ oportunidad_id: id, marcado: marcado })
          .subscribe({
            next: (data: any) => {
              console.log(data);
            },
            error: (err: any) => {
              console.error(err);
            },
          });
      }
    }
  }

  editNextStep(i: number, texto: string, event: Event) {
    event.stopPropagation();
    this.isEditing = true;

    if (this.editStep === i) {
      this.editStep = -1;
      this.isEditing = false;
    } else {
      this.editStep = i;
      this.ultimoEditado = { tipo: 'sgte_paso', index: i };
    }
    this.sgtePaso = texto;
  }

  editOppAmount(i: number, amount: string, event: Event) {
    event.stopPropagation();
    this.isEditing = true;
    if (this.editAmount === i) {
      this.editAmount = -1;
      this.isEditing = false;
    } else {
      this.editAmount = i;
      this.ultimoEditado = { tipo: 'importe', index: i };
    }
    this.previousAmount = amount;
    this.actualAmount = amount;
  }

  saveNextStep(i: number, id: string) {
    this.editStep = -1;
    this.isEditing = false;

    for (let i = 0; i < this.oportunidades.length; i++) {
      if (this.oportunidades[i].oportunidad_id === id) {
        this.oportunidades[i].sgte_paso = this.sgtePaso;

        this.api
          .changeSgtePasoOpportunity({
            oportunidad_id: id,
            sgte_paso: this.sgtePaso,
          })
          .subscribe({
            next: (data: any) => {
              console.log(data);
            },
            error: (err: any) => {
              console.error(err);
            },
          });
      }
    }
    console.log(
      'Guarda proximo paso de ' +
        i +
        ' ' +
        id +
        ' Y el texto es ' +
        this.sgtePaso
    );
  }

  saveNewAmount(i: number, id: string) {
    this.editAmount = -1;
    this.isEditing = false;

    let data = {
      oportunidad_id: id,
      importe_actual: this.actualAmount,
      importe_antes: this.previousAmount,
    };
    for (let i = 0; i < this.oportunidades.length; i++) {
      if (this.oportunidades[i].oportunidad_id === id) {
        this.oportunidades[i].importe_actual = this.actualAmount;
        this.oportunidades[i].importe_antes = this.previousAmount;

        this.api.updateAmountOpportunity(data).subscribe({
          next: (data: any) => {
            console.log(data);
          },
          error: (err: any) => {
            console.error(err);
          },
        });
      }
    }
  }

  reabrirUltimoEditado() {
  if (!this.ultimoEditado) {
    this.mostrarMensaje('No hay edición previa para reabrir.', 'advertencia');
    return;
  }

  const { tipo, index } = this.ultimoEditado;

  this.isEditing = true;

  if (tipo === 'importe') {
    this.editAmount = index; 
  } else if (tipo === 'sgte_paso') {
    this.editStep = index; 
  }

  console.log(`✏️ Reabriendo última edición: ${tipo} en fila ${index}`);
}


  checkMarkedOpportunities() {
    const arr = [];

    for (let i = 0; i < this.all_oportunidades.length; i++) {
      if (this.all_oportunidades[i].marcado === 1) {
        arr.push(this.all_oportunidades[i]);
      }
    }

    if (this.allMarked) {
      this.allMarked = false;
      this.oportunidades = this.all_oportunidades;
    } else {
      this.allMarked = true;
      this.oportunidades = arr;
    }
  }

  goOpportunitiesList() {
    this.router.navigate(['/opportunities']);
  }

  @HostListener('document:click', ['$event.target'])
  onClickOutside(target: EventTarget | null): void {
    if (!(target instanceof HTMLElement)) return;

    const clickedInsideRecent = this.elementRef.nativeElement
      .querySelector('.dropdown-trigger')
      ?.contains(target);
    const clickedInsideActions = this.elementRef.nativeElement
      .querySelector('.dots-button')
      ?.contains(target);

    if (!clickedInsideRecent) {
      this.showRecentDropdown = false;
    }

    if (!clickedInsideActions) {
      this.openedMenuId = null;
    }
  }

  filtrarOportunidades(): void {
    this.oportunidades = [...this.all_oportunidades];

    if (this.filtros.fecha) {
      const hoy = new Date();
      let inicio: Date | null = null;
      let fin: Date | null = null;

      const primerDiaMes = new Date(hoy.getFullYear(), hoy.getMonth(), 1);
      const ultimoDiaMes = new Date(hoy.getFullYear(), hoy.getMonth() + 1, 0);
      const diaSemana = hoy.getDay();
      const lunesActual = new Date(hoy);
      lunesActual.setDate(hoy.getDate() - diaSemana + 1);
      const domingoActual = new Date(lunesActual);
      domingoActual.setDate(lunesActual.getDate() + 6);

      switch (this.filtros.fecha) {
        case 'semana':
          inicio = lunesActual;
          fin = domingoActual;
          break;
        case 'mes':
          inicio = primerDiaMes;
          fin = ultimoDiaMes;
          break;
        case 'trimestre':
          inicio = new Date(
            hoy.getFullYear(),
            Math.floor(hoy.getMonth() / 3) * 3,
            1
          );
          fin = new Date(inicio.getFullYear(), inicio.getMonth() + 3, 0);
          break;
        case 'semana_siguiente':
          inicio = new Date(lunesActual);
          inicio.setDate(lunesActual.getDate() + 7);
          fin = new Date(inicio);
          fin.setDate(inicio.getDate() + 6);
          break;
        case 'mes_siguiente':
          inicio = new Date(hoy.getFullYear(), hoy.getMonth() + 1, 1);
          fin = new Date(hoy.getFullYear(), hoy.getMonth() + 2, 0);
          break;
        case 'trimestre_siguiente':
          inicio = new Date(
            hoy.getFullYear(),
            Math.floor(hoy.getMonth() / 3) * 3 + 3,
            1
          );
          fin = new Date(inicio.getFullYear(), inicio.getMonth() + 3, 0);
          break;
      }

      if (inicio && fin) {
        this.oportunidades = this.oportunidades.filter((opp: any) => {
          if (!opp.fecha_cierre_estimada) return false;
          const fecha = new Date(opp.fecha_cierre_estimada);
          return fecha >= inicio && fecha <= fin;
        });
      }
    }

    if (this.filtros.propietario) {
      // Si el usuario es ADMIN → puede filtrar por cualquier ejecutivo
      if (
        this.currentUserRole.toLowerCase() === 'administrador' ||
        this.currentUserRole.toLowerCase() === 'admin'
      ) {
        if (this.filtros.propietario !== 'todos') {
          this.oportunidades = this.oportunidades.filter((opp: any) => {
            const ejecutivo = `${opp.contacto?.ejecutivo?.nombre || ''} ${
              opp.contacto?.ejecutivo?.apellido || ''
            }`.trim();
            return ejecutivo === this.filtros.propietario; // 👈 aquí selecciona un ejecutivo específico
          });
        }
      }

      // Si es EJECUTIVO → solo sus propias oportunidades
      else if (this.currentUserRole.toLowerCase() === 'ejecutivo') {
        this.oportunidades = this.oportunidades.filter((opp: any) => {
          const ejecutivo = `${opp.contacto?.ejecutivo?.nombre || ''} ${
            opp.contacto?.ejecutivo?.apellido || ''
          }`.trim();
          return ejecutivo === this.currentUserName;
        });
      }
    }

    if (this.filtros.cambios) {
      console.log("🟧 Filtro 'Cambios desde' activado:", this.filtros.cambios);

      const dias = parseInt(this.filtros.cambios, 10);
      const hoy = new Date();
      const fechaLimite = new Date(hoy);
      fechaLimite.setDate(hoy.getDate() - dias);
      fechaLimite.setHours(0, 0, 0, 0);

      console.log('📅 Fecha límite:', fechaLimite.toISOString());

      this.oportunidades = this.oportunidades.filter((opp: any) => {
        if (!opp.fecha_actualizacion) {
          console.warn('⚠️ Sin fecha_actualizacion:', opp.nombre);
          return false;
        }

        const fechaStr = String(opp.fecha_actualizacion).replace(/\//g, '-');
        let fechaMod: Date;

        try {
          const [year, month, day] = fechaStr
            .split('-')
            .map((v) => parseInt(v, 10));
          fechaMod = new Date(year, month - 1, day);
        } catch {
          fechaMod = new Date(fechaStr);
        }

        fechaMod.setHours(0, 0, 0, 0);

        if (isNaN(fechaMod.getTime())) {
          console.error('❌ Fecha inválida:', opp.fecha_actualizacion);
          return false;
        }

        const enRango = fechaMod >= fechaLimite;
        console.log(
          `🔹 ${opp.nombre}: fecha_actualizacion=${
            opp.fecha_actualizacion
          } | fechaMod=${fechaMod.toISOString()} | >= ${fechaLimite.toISOString()} ? ${enRango}`
        );

        return enRango;
      });
    }
  }

  resetFiltros(): void {
    this.filtros = { fecha: '', propietario: '', cambios: '' };
    this.oportunidades = [...this.all_oportunidades];
  }

  getCurrentUserFromToken(): void {
    const token = localStorage.getItem('crmtoken');
    if (!token) {
      console.warn('⚠️ No se encontró token de sesión.');
      return;
    }

    try {
      const decoded: any = jwtDecode(token);

      const nombre = decoded.nombre || '';
      const apellido = decoded.apellido || '';
      const UserRole = decoded.roleName || '';

      this.currentUserName = `${nombre} ${apellido}`.trim();
      this.currentUserRole = UserRole;
      console.log('👤 Usuario actual:', this.currentUserName);
    } catch (error) {
      console.error('❌ Error al decodificar token:', error);
    }
  }

calcularTotales() {
  this.api.getKpisOportunity().subscribe({
    next: (res: any) => {
      console.log("📌 [Front] Respuesta KPIs:", res);
      this.totales = res.totales || this.totales;
    },
    error: (err) => {
      console.error("❌ Error al cargar KPIs:", err);

      if (err.status === 403) {
        this.alertService.error(
          "Sin permisos",
          "No tienes permiso para ver los indicadores."
        );
        return;
      }

      this.alertService.error(
        "Error",
        "No se pudieron cargar los KPI de oportunidades."
      );
    },
  });
}

  getEjecutivos(): void {
    this.api.getUsers().subscribe({
      next: (res: any) => {
        this.ejecutivos = (res.users || []).map((u: any) => ({
          nombreCompleto: `${u.nombre} ${u.apellido}`.trim(),
        }));
        console.log('👥 Ejecutivos cargados:', this.ejecutivos);
      },
      error: (err: any) => console.error('Error al cargar ejecutivos:', err),
    });
  }
}
